module.exports = __webpack_public_path__ + "img/join_img1.1a425810.jpg";